import React from 'react';
import { ResetForgottenPasswordViewModel } from './ResetForgottenPasswordViewModel';
import { Container, Form, Button, Image, Col, InputGroup } from 'react-bootstrap';
import salvar from '../../Imagens/save-16.png';
import "../../Estilo/ResetForgottenPassword.css";
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import logo from "../../Imagens/logo-login.png";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface MyProps {
    navigation: any;
    delegate: ResetForgottenPasswordViewControllerDelegate;
    viewModel: ResetForgottenPasswordViewModel;
    token: string;
}

export interface ResetForgottenPasswordViewControllerDelegate {
    tapDimiss(navigation: any): void;
}

export class ResetForgottenPasswordViewController extends React.Component<MyProps> {
    state = {
        isLoading: false,
        senha: '',
        confirmarSenha: '',
        showSenha: false,
        showConfirmarSenha: false
    }

    render() {
        return (
            <div className="reset-password-page">
                <Container fluid="sm" className="reset-password-container">
                    <Col lg={12}>
                        <Image
                            src={logo}
                            height={200}
                            width={500}
                            className="center"
                            fluid
                        />
                    </Col>
                    <h3 className='mb-4 mt-2 text-center'>Redefinir senha</h3>
                    <Form>
                        <Form.Group className="mb-3" controlId="senha">
                            <Form.Label className="isRequired">Nova senha</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={this.state.showSenha ? "text" : "password"}
                                    placeholder="Digite a nova senha"
                                    value={this.state.senha}
                                    onChange={(e) => this.setState({ senha: e.target.value })}
                                />
                                <Button
                                    className='showPassword'
                                    variant="outline-secondary"
                                    onClick={() => this.setState({ showSenha: !this.state.showSenha })}
                                >
                                    {this.state.showSenha ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="confirmarSenha">
                            <Form.Label className="isRequired">Confirmar senha</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={this.state.showConfirmarSenha ? "text" : "password"}
                                    placeholder="Confirme a nova senha"
                                    value={this.state.confirmarSenha}
                                    onChange={(e) => this.setState({ confirmarSenha: e.target.value })}
                                />
                                <Button
                                    className='showPassword'
                                    variant="outline-primary"
                                    onClick={() => this.setState({ showConfirmarSenha: !this.state.showConfirmarSenha })}
                                >
                                    {this.state.showConfirmarSenha ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <Button
                            className="w-100 fw-bold d-flex justify-content-center align-items-center"
                            type="button"
                            onClick={() => this.save()}
                            variant="primary"
                        >
                            <Image className="mr-3" src={salvar} />
                            Salvar
                        </Button>
                    </Form>

                    <ToastContainer />
                    <LoaderComponente
                        show={this.state.isLoading}
                        hide={() => this.setState({ isLoading: false })}
                    />
                </Container>
            </div>
        );
    }

    private save() {
        const { senha, confirmarSenha } = this.state;

        if (!senha || !confirmarSenha) {
            this.showFieldsEmpty("Preencha todos os campos obrigatórios!");
            return;
        }

        if (senha !== confirmarSenha) {
            this.showFieldsEmpty("As senhas não coincidem!");
            return;
        }

        this.setState({ isLoading: true });

        const obj = {
            token: this.props.token,
            novaSenha: senha
        };

        this.props.viewModel.fetchSave(obj).then(() => {
            toast.success("Senha redefinida com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                const base = this.props.navigation.match.params.base;
                this.props.navigation.history.push(`/${base}/login`);

            }, 1000);
        }).catch((e) => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
}
